// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Redux Specific
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
// MARK: Styled Components
interface ContainerProps {
  marginleft: number;
}
const Container = styled.div<ContainerProps>`
  pointer-events: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  text-decoration: none;
  margin-left: ${({ marginleft }) => marginleft}px;
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
  background-color: transparent;
`;

interface BarProps {
  transform: string;
  color: string;
}

const Bar = styled.div<BarProps>`
  position: absolute;
  border: 0;
  text-decoration: none;
  width: 100%;
  min-width: 100%;
  height: 1px;
  min-height: 1px;
  background-color: ${({ color }) => color};
  transform-origin: 50% 50%;
  transform: ${({ transform }) => transform};
  transition: 0.6s cubic-bezier(0.19, 1, 0.22, 1);
`;

// MARK: React Component
// Props
interface Props {
  active: boolean;
  color: string;
}
// Component
const PlusOrExit = ({ active, color }: Props) => {
  // MARK: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // MARK: Variables
  const { gutter } = styleguide;
  // MARK: Render
  return (
    <Container marginleft={gutter}>
      <Bar
        transform={active ? "rotate(-45deg)" : "rotate(0deg)"}
        color={color}
      />
      <Bar
        transform={active ? "rotate(45deg)" : "rotate(90deg)"}
        color={color}
      />
    </Container>
  );
};

export default PlusOrExit;
